import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import parse from 'html-react-parser';
import {
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  FormFeedback,
  Row,
  Col,
  Card,
  CardBody,
  CardFooter,
} from "reactstrap";
import { toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import styles from '../../assets/preview.module.scss';
//import storageItem action
import {
  createStorageItem,
  updateStorageItem
  } from "../../redux/actions/storageItems";
import { retrieveStorageCategories } from "../../redux/actions/storageCategories";

//Configure toastify
toast.configure();

const StorageItemForm = (props) => {

  const storageItemDetail = props.storageItemDetail;

  const navigate = useNavigate();

  const dispatch = useDispatch();

  const [currentStorageItemInfo, setCurrentStorageItemInfo] = useState(storageItemDetail);

  const [selectedImage, setSelectedImage] = useState(null);

  const [imagePreview, setImagePreview] = useState("");

  const [removePreviewImg, setRemovePreviewImg] = useState(false);

  const [imageErr, setImageErr] = useState("");

  //states for handling validations
  const [nameErr, setNameErr] = useState("");
  const [titleErr, setTitleErr] = useState("");
  const [displayOrderErr, setDisplayOrderErr] = useState("");

  const [categoryErr, setCategoryErr] = useState("");

  const storageCategories = useSelector(
    (state) => state.storageCategoryReducer.storageCategories
  );

  useEffect(() => {
    
    dispatch(retrieveStorageCategories());

    if (storageItemDetail !== undefined) {
      setCurrentStorageItemInfo(storageItemDetail); //set storage type details in the state when storageItemDetail changes

        console.log("Storage type details updated", storageItemDetail);

        //set profile image preview when userDetail changes
        if (storageItemDetail.image) {
          setImagePreview(
            process.env.REACT_APP_STORAGE_TYPES_IMAGE_URL + storageItemDetail.image
          );
        }
    }
  }, [storageItemDetail]);

  //input change handler
  const handleInputChange = (event) => {

    const { name, value } = event.target;

    setCurrentStorageItemInfo({ ...currentStorageItemInfo, [name]: value });
    
  };

  //validation handler
  const handleValidation = (event) => {

    const inputValue = event.target.value.trim();

    const inputFieldName = event.target.name;

    //set error message for firstName
    if (inputFieldName === "item") {
      if (inputValue.length < 2) {
        setNameErr("Please enter atleast 2 characters!");
      } else {
        setNameErr("");
      }
    }
    if (inputFieldName === "title") {
      if (inputValue.length < 2) {
        setTitleErr("Please enter atleast 2 characters!");
      } else {
        setTitleErr("");
      }
    }

    if (inputFieldName === "displayOrder") {
      if (parseInt(inputValue.length) <= 0) {
        setDisplayOrderErr("Please enter number greater then 0!");
      } else {
        setDisplayOrderErr("");
      }
    }

  };

  //file input handler
  const handleFileInput = (event) => {
      setImageErr("");

      let fileSize = 0;

      let errorCount = 0;

      const file = event.target.files[0];

      if (file) {
          fileSize = file.size / 1024;

          if (!file.name.match(/\.(jpg|jpeg|png|gif)$/i)) {
              setImageErr("Only Images are allowed! ");

              errorCount++;
          }

          //check if filesize is not more than 1MB
          if (fileSize > 1024) {
              setImageErr("Please upload a file of size less than 1MB!");

              errorCount++;
          }

          if (errorCount === 0) {
              const imageAsBase64 = URL.createObjectURL(file);

              setSelectedImage(file);

              setImagePreview(imageAsBase64);

              setRemovePreviewImg(false);

          }
      }
  };

  const removeProfilePicture = (event) => {

      event.preventDefault();

      setImagePreview("");

      setSelectedImage(null);

      setRemovePreviewImg(true);
  }

  //update form handler
  const submitHandler = (event) => {

    event.preventDefault();

    let errorCount = 0;

    const formData = new FormData();

    if (
      JSON.stringify(currentStorageItemInfo) === "{}" ||
      currentStorageItemInfo.item === "" ||
      currentStorageItemInfo.item === null ||
      currentStorageItemInfo.item.length < 2
    ) {
        setNameErr("Please enter atleast 2 characters!");

      errorCount++;
    } else {
      formData.append("item", currentStorageItemInfo.item);

      setNameErr("");
    }

    if (
      JSON.stringify(currentStorageItemInfo) === "{}" ||
      currentStorageItemInfo.title === "" ||
      currentStorageItemInfo.title === null ||
      currentStorageItemInfo.title.length < 2
    ) {
        setNameErr("Please enter atleast 2 characters!");

      errorCount++;
    } else {
      formData.append("title", currentStorageItemInfo.title);

      setNameErr("");
    }

    if (
      JSON.stringify(currentStorageItemInfo) === "{}" ||
      currentStorageItemInfo.storageCategoryId === "" ||
      currentStorageItemInfo.storageCategoryId === null
    ) {
      setCategoryErr("Please select storage type!");
      errorCount++;
    } else {
      formData.append(
        "storageCategoryId",
        currentStorageItemInfo.storageCategoryId
      );
      setCategoryErr("");
    }


    if (imageErr !== "") {
        errorCount++;
    } else {
        if (selectedImage !== null)
            formData.append("storageItemImage", selectedImage);
    }

    if(removePreviewImg){
        formData.append("removeStorageImage", removePreviewImg);
    }

    if (
      JSON.stringify(currentStorageItemInfo) === "{}" ||
      currentStorageItemInfo.displayOrder === "" ||
      parseInt(currentStorageItemInfo.displayOrder) <= 0
    ) {
      setDisplayOrderErr("Please enter number greater then 0!");
      errorCount++;
    } else {
      formData.append("displayOrder", currentStorageItemInfo.displayOrder);
      setDisplayOrderErr("");
    }

    /*for ( var pair of formData.entries() ) {

        console.log( "FormData:",pair[0]+ ', ' + pair[1] ); 

    }*/

    if (errorCount > 0) {
      return;
    } else {
      if (JSON.stringify(props.storageItemDetail) !== "{}") {

        //dispatch to update the storage type
        dispatch(updateStorageItem(currentStorageItemInfo.id, formData))
          .then((response) => {
            setCurrentStorageItemInfo({ ...currentStorageItemInfo });

            toast("Storage Item updated successfully!", {
              transition: Slide,

              closeButton: true,

              autoClose: 3000,

              position: "top-right",

              type: "success", // info/success/warning/error
            });
          })
          .catch((error) => {
            toast(error.response.data.message, {
              transition: Slide,

              closeButton: true,

              autoClose: 3000,

              position: "top-right",

              type: "error",
            });
          });
      } else {

        //dispatch to create the storage type
        dispatch(createStorageItem(formData))
          .then((response) => {
            toast("Storage Item created successfully!", {
              transition: Slide,

              closeButton: true,

              autoClose: 1000,

              position: "top-right",

              type: "success", // info/success/warning/error
            });

            navigate(`/storageItem/${response.storageItemInfo.id}`);
          })
          .catch((error) => {
            toast(error, {
              transition: Slide,

              closeButton: true,

              autoClose: 3000,

              position: "top-right",

              type: "error",
            });
          });
      }
    }
  };

  return (
    <>
      {currentStorageItemInfo ? (
        <Row>
          <Col md="12">
            <Card className="main-card mb-3">
              <Form>
                <CardBody>
                  <Row>
                    <Col md="12">
                      <FormGroup>
                        <Label for="item">Name</Label>
                        <Input
                          invalid={nameErr !== "" ? true : false}
                          type="text"
                          name="item"
                          id="item"
                          placeholder="Name here..."
                          value={
                            currentStorageItemInfo.item ? currentStorageItemInfo.item : ""
                          }
                          onChange={handleInputChange}
                          onKeyUp={handleValidation}
                        />
                        {nameErr !== "" && (
                          <FormFeedback>{nameErr}</FormFeedback>
                        )}
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="12">
                      <FormGroup>
                        <Label for="title">Title</Label>
                        <Input
                          invalid={titleErr !== "" ? true : false}
                          type="text"
                          name="title"
                          id="title"
                          placeholder="Title here..."
                          value={
                            currentStorageItemInfo.title ? currentStorageItemInfo.title : ""
                          }
                          onChange={handleInputChange}
                          onKeyUp={handleValidation}
                        />
                        {titleErr !== "" && (
                          <FormFeedback>{titleErr}</FormFeedback>
                        )}
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <FormGroup>
                      <Label for="storageCategoryId">Storage Type</Label>
                      <Input
                        invalid={categoryErr !== "" ? true : false}
                        id="storageCategoryId"
                        name="storageCategoryId"
                        type="select"
                        value={
                          currentStorageItemInfo.storageCategoryId
                            ? currentStorageItemInfo.storageCategoryId
                            : ""
                        }
                        onChange={(event) => {
                          handleInputChange(event); 
                          handleValidation(event);
                        }}
                      >
                        <option value={""}>Select Category</option>
                        {storageCategories &&
                          storageCategories.map((category, index) => (
                            <option key={index} value={category.id}>
                              {category.name}
                            </option>
                          ))}
                      </Input>

                      {(() => {
                        console.log("error =>", [categoryErr, nameErr]);
                      })()}
                      {categoryErr !== "" && <FormFeedback>{categoryErr}</FormFeedback>}
                    </FormGroup>
                  </Row>

                  <Row>
                      <FormGroup>
                          <Label for="storageItemImage">Image</Label>
                          <Input
                              invalid={imageErr !== "" ? true : false}
                              type="file"
                              name="storageItemImage"
                              id="storageItemImage"
                              accept="image/*"
                              onChange={handleFileInput}
                          />
                          {imagePreview && (
                              <div className={styles.previewContainer}>
                              <img
                                  width={100}
                                  src={imagePreview}
                                  alt="preview"
                                  onError = {() => setImagePreview(`${process.env.REACT_APP_NO_IMAGE_URL}`)} 
                              />
                              <a href="#" className={styles.deleteIcon} onClick={removeProfilePicture}>
                                  <i className="pe-7s-trash"></i>
                              </a>
                              </div>
                          )}
                          {imageErr !== "" && (
                              <FormFeedback>{imageErr}</FormFeedback>
                          )}
                      </FormGroup>
                    </Row>

                    <Row>
                    <Col md="12">
                      <FormGroup>
                        <Label for="displayOrder">Display Order</Label>
                        <Input
                          invalid={displayOrderErr !== "" ? true : false}
                          type="number"
                          name="displayOrder"
                          id="displayOrder"
                          placeholder="Enter number"
                          value={
                            currentStorageItemInfo.displayOrder ? currentStorageItemInfo.displayOrder : ""
                          }
                          onChange={handleInputChange}
                          onKeyUp={handleValidation}
                        />
                        {displayOrderErr !== "" && (
                          <FormFeedback>{displayOrderErr}</FormFeedback>
                        )}
                      </FormGroup>
                    </Col>
                  </Row>
                </CardBody>
                <CardFooter className="d-block">
                  <Button
                    className="me-2"
                    color="link"
                    onClick={() => {
                      navigate(`/storageItem/list`);
                    }}
                  >
                    Cancel
                  </Button>
                  <Button size="lg" color="primary" onClick={submitHandler}>
                    {JSON.stringify(props.storageItemDetail) !== "{}"
                      ? "Update"
                      : "Save"}
                  </Button>
                </CardFooter>
              </Form>
            </Card>
          </Col>
        </Row>
      ) : (
        <Row>
          <Col md="12">
            <Card className="main-card mb-3">
              <p>You are not authorized to access the page!</p>
            </Card>
          </Col>
        </Row>
      )}
    </>
  );
};

export default StorageItemForm;
